export default __webpack_public_path__ + "static/media/screen_facebook_1_3.7c893024.png";